import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';
import { ICollectionModel } from './interfaces/collection-model.interface';

@Injectable({
  providedIn: 'root'
})
export class CollectionModelService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService
  ) {
    super(http, authService, 'collection-model');
  }

  findByName(name: string): Observable<ICollectionModel> {
    if (!name) {
      throw new Error('CollectionModelService.findByName() input parameter is empty');
    }
    return this.http.get<ICollectionModel>(
      this.apiUrl + '/collection-model/name/' + name,
      { headers: { Authorization: 'Bearer ' + this.authService.getToken() } }
    );
  }
}
